const AddressView = ({
  title,
  name,
  street1,
  street2,
  city,
  state,
  zip,
  country,
}) => {
  return (
    <div className="-mx-2">
      <table>
        <thead>
          <tr>
            <th colSpan={2}>{title}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <label htmlFor="">Name: </label>
            </td>
            <td className="w-full">{name}</td>
          </tr>
          <tr>
            <td>
              <label htmlFor="">Street Address: </label>
            </td>
            <td className="w-full">{street1}</td>
          </tr>
          <tr>
            <td>
              <label htmlFor="">Street Address 2: </label>
            </td>
            <td className="w-full">{street2}</td>
          </tr>
          <tr>
            <td>
              <label htmlFor="">City: </label>
            </td>
            <td className="w-full">{city}</td>
          </tr>
          <tr>
            <td>
              <label htmlFor="">State: </label>
            </td>
            <td className="w-full">{state}</td>
          </tr>
          <tr>
            <td>
              <label htmlFor="">Zip Code: </label>
            </td>
            <td className="w-full">{zip}</td>
          </tr>
          <tr>
            <td>
              <label htmlFor="">Country: </label>
            </td>
            <td className="w-full">{country}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default AddressView;
